import ownerDocument from './owner-document';

var getWindow = function (element) { return ownerDocument(element).defaultView; };

export default getWindow;



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-popup-common/dist/es/window.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/window.js
// module chunks = 3